class ModalAdminSticker {
  constructor (opts) {
    const that = this;

    this.opts = {
      baseUrl: INKIVE.C.BASE_URL,
      staticUrl: INKIVE.C.STATIC_URL,
      ...opts
    };

    this.$wrapper = $(
      this.opts.wrapper
        ? $.parseHTML(this.opts.wrapper)
        : $.parseHTML('<div class="tool-content"></div>')
    );

    this.data = null;

    loadData(function () {
      initTemplate();
      initData(that.data);
    });

    /** ** Private methods *********************************************************************************************/

    function initTemplate () {
      let type = 'sticker';
      if (that.opts.isText) type = 'banner';
      if (that.opts.isPlaceholder) type = 'placeholder';

      const categoryHtml = type === 'sticker'
        ? `<label>${INKIVE.TranslateHelper.translate('modal.admin_sticker.category')}</label>
        <input type="text" name="categories" data-role="tagsinput"/>`
        : '';

      const html =
        `<div style="display: table; width:100%">
          <div style="display: table-cell; width:300px; vertical-align: top; padding-right: 15px;">
            <section>
              <img src="${INKIVE.C.THUMB_NOCOVER}" style="border: 1px solid rgb(49, 61, 67);width:107px;" />
              <div class="checkbox"><input type="checkbox" name="isActive" value="1" />
                <label for="isActive">
                  ${INKIVE.TranslateHelper.translate('modal.admin_sticker.is_active_' + type)}
                </label>
              </div>
              ${categoryHtml}
            </section>
          </div>
          <div style="display: table-cell; vertical-align: top;">
            <section>
              <label for="name">
                ${INKIVE.TranslateHelper.translate('modal.admin_sticker.name_' + type)}
              </label>
              <input type="text" name="name" class="form-control" data-popover="tooltip"
                data-original-title="${INKIVE.TranslateHelper.translate('modal.admin_sticker.name_tooltip')}" />
            </section>
            <label for="tags">
              ${INKIVE.TranslateHelper.translate('modal.admin_sticker.tags')}
            </label>
            <div data-popover="tooltip"
              data-original-title="${INKIVE.TranslateHelper.translate('modal.admin_sticker.tags_tooltip')}">
              <input type="text" name="tags" data-role="tagsinput" />
            </div>
            <section>
              <label for="set">
                ${INKIVE.TranslateHelper.translate('modal.admin_sticker.priority')}
              </label>
              <input type="text" name="set" data-role="tagsinput" data-popover="tooltip"
                    data-original-title="${INKIVE.TranslateHelper.translate('modal.admin_sticker.priority_tooltip')}" />
            </section>
          </div>
        </div>`;

      that.$wrapper.append($.parseHTML(html));

      that.$wrapper.find('[data-popover="tooltip"]').tooltip({
        placement: 'auto',
        html: true
      });

      that.$wrapper.trigger('contentChanged');
    }

    function initData (data) {
      // Thumb
      const $img = that.$wrapper.find('img');
      $img.hide();
      INKIVE.Helpers.imageLoader(data.url, function (status, img) {
        const cover =
          status === INKIVE.C.Status.success ? data.url : INKIVE.C.THUMB_NOCOVER;

        $img.attr('src', cover).fadeIn('slow');
      });

      // Name
      const $name = that.$wrapper.find('[name="name"]');
      if (data.name) $name.val(data.name);
      $name.keyup(function (event) {
        const text = $(this).val();
        $(this).val(
          text
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9\-_]/g, '')
        );
      });

      // Set
      const $set = that.$wrapper.find('[name="set"]');
      if (data.set) $set.val(data.set);
      $set.keyup(function (event) {
        const text = $(this).val();
        $(this).val(text.trim().replace(/[^0-9]/g, ''));
      });

      // Category
      const $categories = that.$wrapper.find('[name="categories"]');
      const categories = INKIVE.Tool._cache.stickerCategories;
      $categories.tagsinput({
        itemValue: function (item) {
          return item.name;
        },
        itemText: function (item) {
          return item.name;
        },
        typeahead: { source: categories }
      });

      if (data.category) {
        data.category.split(',').forEach((name) => {
          const category = _.find(INKIVE.Tool._cache.stickerCategories, {
            name
          });
          category && $categories.tagsinput('add', category);
        });
        that.$wrapper.trigger('contentChanged');
      }

      // Tags
      const $tags = that.$wrapper.find('[name="tags"]');
      $tags.tagsinput({ itemValue: 'id', itemText: 'name' });
      if (data.tag) {
        data.tag.split(',').forEach((tag) => {
          $tags.tagsinput('add', { id: tag, name: tag });
        });
        that.$wrapper.trigger('contentChanged');
      }

      $tags.tagsinput('input').keyup(function (event) {
        const keycode = event.keyCode ? event.keyCode : event.which;
        let text = $(this).val();
        text = text.replace(/[^a-zA-Z0-9, ]/g, '');
        $(this).val(text);
        if (keycode === 13 || keycode === 188) {
          text = text.trim().replace(/,/g, '');
          $tags.tagsinput('add', { id: text, name: text });
          $tags.tagsinput('input').val('');
        }
      });

      $tags.tagsinput('input').change(function (event) {
        const text = $(this).val();
        $tags.tagsinput('add', { id: text, name: text });
        $tags.tagsinput('input').val('');
      });

      // Is active
      const checked = 'check';
      if (parseInt(data.active)) {
        that.$wrapper.find('[name=isActive]').attr('checked', checked);
      }
      if (parseInt(data.isText)) {
        that.$wrapper.find('[name=isText]').attr('checked', checked);
      }
    }

    function loadData (callback) {
      callback = callback || $.noop;

      INKIVE.Modal.loader(that.$wrapper);

      if (that.opts.id) {
        INKIVE.Helpers.api(
          'search/sticker',
          'GET',
          { id: that.opts.id },
          function (r) {
            INKIVE.Modal.loaderClose(that.$wrapper);

            if (r.id) {
              that.data = r || {};
              callback();
            } else {
              that.$wrapper.append(
                'Error in loading sticker ID ' + that.opts.id
              );
            }
          }
        );
      } else if (that.opts.data) {
        INKIVE.Modal.loaderClose(that.$wrapper);

        that.data = that.opts.data;
        callback();
      } else {
        INKIVE.Modal.loaderClose(that.$wrapper);

        that.data = {};
        callback();
      }
    }
  }

  getFormHtml () {
    return this.$wrapper;
  }

  getData () {
    return this.data;
  }

  getFormData () {
    return {
      id: this.data.id,
      set: this.$wrapper.find('[name="set"]').val(),
      tag: this.$wrapper.find('[name="tags"]').val(),
      name: this.$wrapper.find('[name="name"]').val(),
      active: this.$wrapper.find('[name=isActive]').is(':checked') ? 1 : 0,
      category: this.$wrapper.find('[name="categories"]').val(),

      isText: this.opts.isText,
      isPlaceholder: this.opts.isPlaceholder
    };
  }

  saveForm (callback) {
    callback = callback || $.noop;
    const that = this;

    const info = that.getFormData();

    INKIVE.Helpers.api(
      'management/stickerinfo',
      'POST',
      {
        info
      },
      function (r) {
        if (r && r.status === 'success') {
          callback(true, { ...that.getData(), ...info, id: r.id }); // eslint-disable-line node/no-callback-literal
        } else {
          INKIVE.Modal.alertMessage(
            '<b>Error - </b><i>Updating sticker info</i><br>'
          );
          callback(false); // eslint-disable-line node/no-callback-literal
        }
      }
    );
  }

  deleteForm (callback) {
    callback = callback || $.noop;
    const that = this;

    const info = that.getFormData();

    INKIVE.Helpers.api(
      'management/sticker',
      'DELETE',
      {
        id: info.id
      },
      function (r) {
        if (r && r.status === 'success') {
          callback(true); // eslint-disable-line node/no-callback-literal
        } else {
          INKIVE.Modal.alertMessage('<b>Error - </b><i>Delete sticker</i><br>');
          callback(false); // eslint-disable-line node/no-callback-literal
        }
      }
    );
  }
}

module.exports = ModalAdminSticker;
